import { render, staticRenderFns } from "./WhatsappBusinessIcon.vue?vue&type=template&id=a76c9304"
import script from "./WhatsappBusinessIcon.vue?vue&type=script&lang=js"
export * from "./WhatsappBusinessIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports